module.exports = __webpack_public_path__ + "fonts/Freude-Normal.1d697039.woff";